export default {"src":"/_next/static/media/LogoIpsum2.54046d2d.svg","height":32,"width":169,"blurWidth":0,"blurHeight":0};